// js
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UsageQuestionForm from './UsageQuestionForm';
import ValueRealizedQuestionForm from './ValueRealizedQuestionForm';
import { makeGetIsActiveArea } from '../../selectors/dsa/areaSelectors';
import { makeGetSubAreaUsageProgress } from '../../selectors/dsa/usageSelectors';
import QuestionAccordion from '../common/QuestionAccordion';


function UsageStackItem({
  subarea,
  progress,
  active,
  useQuestions,
  dsaUseQuestions,
  valueRealized,
  dsaValueRealized,
  toggleSubArea,
  answerDSAUseQuestion,
  answerDSAValueRealized
}) {

  return (
    <QuestionAccordion
      title={subarea.title}
      open={active}
      itemsCompleteCount={progress.current}
      itemsTotalCount={progress.total}
      onToggle={() => toggleSubArea(subarea.id)}
    >
      <table className='table use-question-table'>
        <thead>
          <tr>
            <th>
              <label className='h6 label'>Is Splunk in use by the {subarea.title} team to achieve the following functions for currently indexed data?</label>
            </th>
          </tr>
        </thead>
        <tbody>
          {
          // If we have use questions,
          useQuestions &&
          // Find just the ones for the selected sub area and map to striped table rows
          useQuestions
            .filter(uq => uq.subarea === subarea.id)
            .sort((a, b) => a.order - b.order)
            .map(uq => {

              // get the user-input data for this 'configured item'
              const auq = dsaUseQuestions.find(auq => auq.usequestion === uq.id);

              return (
                <tr key={uq.id}>
                  <td>
                    <UsageQuestionForm dsaUserQuestion={auq} userQuestion={uq} updateAnswer={answerDSAUseQuestion} />
                  </td>
                </tr>
              );
            }
          )}
        </tbody>
      </table>
      <table className='table use-question-table'>
        <thead>
          <tr>
            <th>
              <label className='h6 label'>What type of value has the {subarea.title} team realized from using Splunk so far?</label>
            </th>
          </tr>
        </thead>
        <tbody>
          {
          valueRealized &&
            valueRealized
            .filter(vrq => vrq.subarea === subarea.id)
            .sort((a, b) => a.order - b.order)
            .map(vrq => {

              const vra = dsaValueRealized.find(answer => answer.valuerealized === vrq.id);

              return (
                <tr key={vrq.id}>
                  <td>
                    <ValueRealizedQuestionForm question={vrq} answer={vra} updateAnswer={answerDSAValueRealized} />
                  </td>
                </tr>
              );
            }
          )}
        </tbody>
      </table>
    </QuestionAccordion>
  );
}

const mapStateToProps = (state, props) => {
  const getIsActiveArea = makeGetIsActiveArea();
  const getSubAreaUsageProgress = makeGetSubAreaUsageProgress();
  return {
    isActiveArea: getIsActiveArea(state, props),
    progress: getSubAreaUsageProgress(state, props)
  };
};

UsageStackItem.propTypes = {
  subarea: PropTypes.object.isRequired,
  useQuestions: PropTypes.array,
  dsaUseQuestions: PropTypes.array,
  valueRealized: PropTypes.array,
  dsaValueRealized: PropTypes.array,
  active: PropTypes.bool,
  progress: PropTypes.object,
  toggleSubArea: PropTypes.func,
  answerDSAUseQuestion: PropTypes.func,
  answerDSAValueRealized: PropTypes.func
};

export default connect(mapStateToProps)(UsageStackItem);



// WEBPACK FOOTER //
// ./src/components/usage/UsageStackItem.js